import React from "react";
import FontAwesome from "react-fontawesome";
import Checkbox from "js/components/account/account-form-checkbox";
import UserHandler from "../../utilities/user-handler";
import Api from "../../utilities/fnapi-client";

/*
 * This table is used in two places
 * It is the primary "Users" table for all user accounts belonging to the company object
 * It is ALSO rendered on each application row under the "External Users" tab
 * It is passed an entityType prop which will be either "company" or "application"
 *
 * "Company Users" have an optional permission to "Administer Users", application users do *not*
 * This is the major change there are also differences in how data should be updated on ZAPI
 *
 */
export default React.createClass({

  render: function () {

    // We want different headers if we're on the company or application level
    // It was difficult to decide if company user and application user tables should be the same component
    // Eventually, I opted for yes, so there are a lot of conditions branching between the two user table types
    var tableHeader;
    if (this.props.entityType === "company") {
      tableHeader =
        <div className="account-table-header">
          <div className="account-table-left">
            <span className="account-name">Email</span>
          </div>
          <div className="account-table-right">
            <span>View</span>
            <span>Edit</span>
            <span>Manage<br />Users</span>
            <span>&nbsp;</span>
          </div>
        </div>;
    } else {
      tableHeader =
        <div className="account-table-header">
          <div className="account-table-left">
            <span className="account-name">Email</span>
          </div>
          <div className="account-table-right">
            <span>View</span>
            <span>Edit</span>
            <span>&nbsp;</span>
          </div>
        </div>;
    }

    return (
      <div className="account-table user-table">
        {tableHeader}
        <div className="account-table-body">
          {this.state.users.map(this.renderRow)}
        </div>
        { this.footer() }
      </div>

    );
  },

  footer: function(){
    return (
      <div className="account-table-footer">
        <div className="account-table-left">
            <span>
              <input placeholder="Add new email" type="text" value={this.state.newUserEmail} onChange={(e)=>{this.updateNewserEmail(e.target.value)}} />
              { (this.props.canEdit && this.state.modified) &&
              <button onClick={this.saveUpdate} className="account-form-submit">Update</button>
              }
            </span>
        </div>

        <div className="account-table-right">

          <span>
            <Checkbox
              checked={this.state.newUserRoles.indexOf("VIEW") > -1}
              onClick={() => this.toggleNewUserRole('VIEW')}
              disabled={true}
            />
          </span>

          <span>
            <Checkbox
              checked={this.state.newUserRoles.indexOf("EDIT") > -1}
              onClick={() => this.toggleNewUserRole('EDIT')}
            />
          </span>

          {this.props.entityType === "company" &&
            <span>
              <Checkbox
                checked={this.state.newUserRoles.indexOf("ADMINISTER_USERS") > -1}
                onClick={() => this.toggleNewUserRole('ADMINISTER_USERS')}
              />
            </span>
          }

          <span>
            {!this.state.processingNewUser &&
              <FontAwesome name="plus" className="green" onClick={this.createUser} />
            }
            {this.state.processingNewUser &&
              <FontAwesome name="circle-o-notch" className="form-icon fa-spin processing" />
            }
          </span>

        </div>

      </div>
    );
  },

  renderRow: function(item) {
    return <this.props.row {...item} key={item.uid} entityType={this.props.entityType} appToken={this.props.appToken} />;
  },

  getInitialState: function() {
    return {
      users: this.props.dataSource,
      processingNewUser: false,
      newUserEmail: null,
      newUserRoles: [
        "VIEW",
        "EDIT",
      ]
    }
  },

  toggleNewUserRole: function(role){
    // Create a temporary array with the requested change
    var roles = this.state.newUserRoles;
    var index = roles.indexOf(role);
    if (index === -1) {
      roles.push(role);
    } else {
      roles.splice(index, 1);
    }
    this.setState({
      newUserRoles: roles
    });
  },

  updateNewserEmail(value){
    this.setState({
      newUserEmail: value
    });
  },

  createUser(){
    this.setState({
      processingNewUser: true
    });

    // We're going to use a different endpoint for updating applications and companies
    var endpoint;
    if (this.props.entityType === 'company'){
      endpoint = 'account/user';
    }
    else {
      endpoint = 'application/' + this.props.appToken + '/user';
    }

    let payload = {
      roles: this.state.newUserRoles,
      email: this.state.newUserEmail
    };

    // Post the roles and update the state on response
    Api.post(endpoint,payload).then( (response) => {
      // This is the response if a new user was created
      if (response.meta.code == 201){

        let users = this.state.users.slice(); //creates the clone of the state
        users.push(response.data);
        this.setState({
          users: users,
          processingNewUser: false,
          newUserEmail: null,
        });
      }

      // This means the user was just updated. They already belong to the company. What to do?
      else if (response.meta.code == 200){

      }
      this.setState({
        processingNewUser: false,
        newUserEmail: null
      });

    }).catch( (error) => {

      this.setState({
        error: error.message,
        processingNewUser: false
      });

      alert(error.message);

    });


  }


});



// WEBPACK FOOTER //
// ./src/js/components/account/account-table-user.jsx